/** 等待{{time}}秒 */
export function sleep(time = 2) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
    }, time * 1000)
  })
}
